import { FeatureTrack } from "@sp-crm/core";
import { useMutation, useQuery } from "@tanstack/react-query";
import { ContentFull, ContentHeader } from "components/layout";
import { trpc } from "components/rpc/trpc";
import { Toggle } from "components/ui/toggle";
import React, { useCallback } from "react";

export const AgencySettingsFeatures: React.FC<unknown> = () => {
    const trpcClient = trpc.useTRPC();
    const { data: tenantFeatureTrack, refetch: refetchTenantFeatureTrack } = useQuery(
        trpcClient.feature.getTenantFeatureTrack.queryOptions(),
    );

    const updateTenantFeatureTrackMutation = useMutation({
        ...trpcClient.feature.updateTenantFeatureTrack.mutationOptions(),
        onSuccess: () => {
            refetchTenantFeatureTrack();
        },
    });

    const handleUpdateTenantFeatureTrack = useCallback(
        (isChecked: boolean) => {
            updateTenantFeatureTrackMutation.mutate({
                featureTrack: isChecked ? FeatureTrack.Beta : FeatureTrack.Standard,
            });
        },
        [updateTenantFeatureTrackMutation],
    );

    return (
        <ContentFull>
            <ContentHeader>Features</ContentHeader>
            <div className="space-y-4 max-w-lg">
                <div className="space-y-1 lg:space-y-2 group">
                    {tenantFeatureTrack ? (
                        <>
                            <Toggle
                                label={
                                    <div>
                                        <span className="text-md">
                                            Enable early access features
                                        </span>
                                        <p className="text-gray-500 group-hover:text-gray-900 text-sm">
                                            Get early access to new features before they
                                            are released!
                                        </p>
                                    </div>
                                }
                                checked={
                                    tenantFeatureTrack.featureTrack === FeatureTrack.Beta
                                }
                                onChange={handleUpdateTenantFeatureTrack}
                            />
                        </>
                    ) : null}
                </div>
            </div>
        </ContentFull>
    );
};
